export const imageUpload = {
  IMAGE_UPLOAD_LOADING: 'IMAGE_UPLOAD_LOADING',
  IMAGE_UPLOAD_SUCCESS: 'IMAGE_UPLOAD_SUCCESS',
  IMAGE_UPLOAD_FAILURE: 'IMAGE_UPLOAD_FAILURE'
};
